import { GET_OFFICES } from '../actions/types'

const initialState = {}


export default function (state = initialState, action) {
    switch (action.type) {
        case GET_OFFICES:
            return {
                ...state,
                getOfficesResponse: action.payload
            }
        default:
            return state
    }
} 